/**
 * How a member's name is resolved, in one place.
 *
 * `display_name` is what they chose for themselves and always wins. Everything
 * after it is the real account name from Google, which the OAuth sync rewrites
 * on every login — fine as a fallback, never as an override.
 */
export const displayNameOf = (user) => {
  if (!user) return "";
  if (user.display_name && user.display_name.trim()) return user.display_name.trim();

  const real = [user.first_name, user.last_name].filter(Boolean).join(" ").trim();
  if (real) return real;
  if (user.username) return user.username;
  if (user.email) return user.email.split("@")[0];
  return "";
};

/** The Google account name, shown as context when choosing a display name. */
export const realNameOf = (user) =>
  [user?.first_name, user?.last_name].filter(Boolean).join(" ").trim() || user?.username || "";

/** True when the member has not chosen a name yet, so we should ask. */
export const needsDisplayName = (user) =>
  !!user && !(user.display_name && String(user.display_name).trim());
